import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="columns-3, layout, third"><path d="M8 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75C3 4.67893 4.67893 3 6.75 3H8V21Z" fill="currentColor"/><path d="M14.5 3V21H9.5V3H14.5Z" fill="currentColor"/><path d="M17.25 3C19.3211 3 21 4.67893 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H16V3H17.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconColumns3;
